
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { useLogoutMutation } from 'src/redux/api/auth';
import { AppDispatch } from 'src/redux/dispatch';
import { getAuth, logoutCompleted, logoutFromUser } from 'src/redux/slices/auth';
import { getInventory, setInventory } from 'src/redux/slices/inventory';

type LogoutModalProps = {
  superAdminFullLogout?: boolean;
};

export const useLogoutModal = ({superAdminFullLogout}: LogoutModalProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const auth = useSelector(getAuth);
  const inventory = useSelector(getInventory);
  const [openModalLogout, setOpenModalLogout] = useState(false);
  const [logout, { isLoading }] = useLogoutMutation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const showModalLogout = () => {
    setOpenModalLogout(true);
  };

  const handleOkModalLogout = () => {
    if (auth.superAdminToken && !superAdminFullLogout) {
      dispatch(logoutFromUser());
      dispatch(setInventory({...inventory, data: []}));
      navigate(ROUTES.LOGIN);
      setOpenModalLogout(false);
    } else {
      logout({})
        .unwrap()
        .then(() => {
          dispatch(logoutCompleted());
          dispatch(setInventory({...inventory, data: []}));
          setOpenModalLogout(false);
        }).catch(e => {
          console.log(e)
          if (e.status === 401 && e?.data?.error === 'INVALID_TOKEN') {
            dispatch(logoutCompleted());
            dispatch(setInventory({...inventory, data: []}));
            setOpenModalLogout(false);
          }
        });
    }
  };

  const handleCancelModalLogout = () => {
    setOpenModalLogout(false);
  };

  return {
    openModalLogout,
    showModalLogout,
    handleOkModalLogout,
    handleCancelModalLogout,
    fetching: isLoading,
    modalTitle: auth.superAdminToken && !superAdminFullLogout ? t('loginScreen:logout_from_user') : t('loginScreen:logout')
  }
}